module.exports = "/_next/static/images/TrrystDataSuiteBanner-6185e1dc51b1211a299857b43c663807.svg";